import React from 'react';

import { css } from '@emotion/css';

import { DownloadNgrokAgentButton } from 'pages/setup/Integration/DownloadNgrokAgentButton';

import { Container } from 'components/Container';

export const IntegrationStatusPage = () => (
  <Container
    className={css`
      margin-top: 16px;
    `}
  >
    <DownloadNgrokAgentButton />
  </Container>
);
